import Vue from 'vue'
import Vant from 'vant'
import VueTkUI from '@moke/vue-tkui'
import '../utils/axios'
import filters from '../assets/js/filters'
import mixin from '../assets/js/mixin'
import '@moke/vue-tkui/src/sass/all.scss'
import 'vant/lib/index.css'

// 初始化tkUI
Vue.use(VueTkUI)

Vue.use(Vant)

// 全局filter
for (let name in filters) {
  Vue.filter(name, filters[name])
}
// mixin
Vue.mixin(mixin)
